import { ItemEntity } from '@entities/Item/Types';
import css from './ItemTableRow.module.css';
import { GetItemUnit } from '@modules/Steps/Shared/Helpers/GetItemUnit';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';
import React from 'react';

interface ItemTableRowProps {
    item: ItemEntity;
}

export const ItemTableRow: React.FC<ItemTableRowProps> = ({ item }) => {
    const { title, qty, price } = item;

    const total = typeof qty === 'number' ? qty * Number(price) : Number(price);

    return (
        <div className={css.itemTableRow}>
            <div className={css.itemCell}>
                <span className={css.title}>{title}</span>
                <span>{GetItemUnit(item)}</span>
            </div>

            <div className={css.qty} />

            <div className={css.price}>
                R {FormatNumber(price ?? 0, '0.00')}
            </div>

            <div className={css.total}>R {FormatNumber(total, '0.00')}</div>
        </div>
    );
};
